import { createAsyncThunk } from '@reduxjs/toolkit';
import { sendStreamingMessageAction } from '../api/chatApi';
export const streamingMessageActionSent = createAsyncThunk('chat/sendStreamingMessageAction', ({
  locale,
  onClose,
  onError,
  onProgress,
  messageAction,
  source,
  sourceHostApp,
  sourceHostAppPathname,
  threadId,
  template,
  pageContext,
  isCollaborateMode
}) => sendStreamingMessageAction({
  locale,
  onError,
  onProgress,
  onClose,
  messageAction,
  source,
  sourceHostApp,
  sourceHostAppPathname,
  threadId,
  template,
  pageContext,
  isCollaborateMode
}));